module.exports = __webpack_public_path__ + "static/media/InvitationCode.08c48546.svg";